import React from 'react';
import PropTypes from 'prop-types';
import Button from '@components/Button/Button';
import { styled } from '@mui/material/styles';
// import { useRouter } from 'next/router';
import { useSelector } from 'react-redux';

// import ClearIcon from '@mui/icons-material/Clear';
// import CustomizedTextfield from '@components/custom.textfield/custom.textfield';
const Wrapper = styled('div')`
  .fullBtn {
    background-color: #2499e7;
    min-height: 44;
    min-width: 100%;
    padding: 10px 20px;
    font-size: 14px;
    color: white;
    font-family: 'Montserrat', sans-serif;
  }

  .fullBtn:hover {
    background-color: #208ad0;
  }
  .outlinedBtn {
    border: 1px solid #ebebef;
    min-height: 44;
    min-width: 100%;
    padding: 10px 20px;
    color: #272c3a;
    font-size: 14px;
    font-family: 'Montserrat', sans-serif;
  }
  .Mui-disabled {
    background-color: #bde0f8;
    color: white;
    font-weight: 600;
  }
`;
function OutOfSeats({ setModalType, handleModalOpen, handleAddSeatToolTip }) {
  const { invitedMembers } = useSelector((state) => state.general);
  return (
    <Wrapper>
      <div className='text-custom-font-color dark:text-white'>
        <div className='flex justify-center'>
          <img alt='alert' src='/assets/alert.svg' />
        </div>
        <div className=''>
          <div className='text-center pt-3 '>
            <div className='text-xl font-bold'>
              Oops! You don’t have enough <br /> seat(s) left in your plan!
            </div>
            <div className='w-[90%] m-auto'>
              <p className='monseratregular text-sm pt-3'>
                You only have <b>{invitedMembers?.length}</b> available seats
                left in your plan.
              </p>
              <p className='monseratregular text-sm pt-3'>
                Buy more seats to invite more team members or continue sending
                invites using your available seat(s).
              </p>
            </div>
          </div>
        </div>
        <div className='flex justify-between items-center my-4 gap-5'>
          <div className='w-[35%]'>
            <Button
              className='outlinedBtn'
              onClick={() => setModalType('invite')}
            >
              Send Invite
            </Button>
          </div>
          <div className='w-[60%]'>
            <Button
              className='fullBtn'
              onClick={() => {
                handleModalOpen();
                handleAddSeatToolTip();
              }}
            >
              Buy More Seats
            </Button>
          </div>
        </div>
      </div>
    </Wrapper>
  );
}

OutOfSeats.propTypes = {
  handleModalOpen: PropTypes.func,
  handleAddSeatToolTip: PropTypes.func,
  setModalType: PropTypes.func,
};
export default OutOfSeats;
